import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import { isArray } from 'lodash';
import { MAIL_LOAD_STATUS, } from '@/api/logical/ai_assistant';
import { storeOps } from '@/api/store/api_store';
import { apis, getDingTalkSearchString, getFeiShuUrl } from '@/config';
import { api } from '@/api/api';
import { singletonMiniApp } from './miniapp';
const storeApi = api.getDataStoreApi();
const IMG_TYPES = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'svg', 'SVG', 'gif', 'GIF'];
const ATTACHMENT_KEYS = [
    '_account',
    'downloadContentId',
    'downloadId',
    'fileName',
    'filePreviewUrl',
    'fileType',
    'fileUrl',
    'id',
    'flag',
    'mailId',
    'type',
    'fileSize',
    'attType',
];
const STORE_KEY = 'AI_STORE_KEY';
class AiAssistant {
    constructor() {
        this.sendNotificationHandler = debounce(() => {
            try {
                if (this.multipleActiveIds.length > 0 && this.currentTab.type === 'readMain') {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'listMultiSelect',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (this.configMailLayout === '2' && this.currentTab.type === 'readMain') {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'none',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (this.readMailStatus === MAIL_LOAD_STATUS.EMPTY && this.currentTab.type === 'readMain') {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'none',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (this.tipOpen) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'listMultiSelect',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (this.currentTab.type === 'read') {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'readMail',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (this.readMailStatus === MAIL_LOAD_STATUS.SUCCESS && this.currentTab.type === 'readMain') {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'readMail',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (['replyWithAttach', 'reply'].includes(this.currentTab.type)) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'writeReply',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (['replyAllWithAttach', 'replyAll'].includes(this.currentTab.type)) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'writeReplyAll',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (['common', 'edit', 'editDraft', 'replyAllAsNew'].includes(this.currentTab.type)) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'writeGeneral',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else if (['forward', 'forwardAsAttach'].includes(this.currentTab.type)) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'writeGeneral',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
                else {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'context',
                        eventData: {
                            action: 'none',
                            poll: false,
                            updatectx: true,
                        },
                    });
                }
            }
            catch (ex) { }
        }, 2000);
        this._testHMRStateSync = 1;
        this.name = 'aiAssistant';
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.systemApi = api.getSystemApi();
        this.storageApi = api.getDataStoreApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.eventApi = api.getEventApi();
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.readMailStatus = MAIL_LOAD_STATUS.EMPTY;
        this.multipleActiveIds = [];
        this.currentTab = {};
        this.configMailLayout = '';
        this.selectedMailId = null;
        this.currentWriteMail = null;
        this.currentMergeMailId = '';
        this.selectedKeysAccountId = '';
        this.aiAssistSideBarVisiable = false;
        this.aiAssistSideBarVisiable_sd = { visiable: false };
        this.preAiAssistSideBarVisiable = false;
        this.eidList = [];
        this.tipOpen = false;
    }
    idIsTreadMail(id) {
        if (id) {
            try {
                const mailIdReg = /\d+/;
                const [realId] = id.split('--') || [''];
                const [res] = mailIdReg.exec(realId) || [null];
                if (res && res.length === realId.length) {
                    return true;
                }
            }
            catch (_a) {
                return false;
            }
            return false;
        }
        return false;
    }
    getUserInfo(account) {
        let currentAccount;
        if (!account) {
            currentAccount = this.systemApi.getCurrentUser();
        }
        else {
            currentAccount = this.systemApi.getCurrentUser(account);
            !currentAccount && (currentAccount = this.systemApi.getCurrentUser());
        }
        return {
            uid: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id) || '',
            nickname: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.nickName) || '',
            avatar: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.avatar) || '',
            job: '',
            phoneNumber: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.mobile) || '',
            isMember: this.productAuthApi.doGetProductVersionId() === 'sirius',
            sid: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.sessionId) || '',
        };
    }
    async doGetMailContent(param) {
        let res = [];
        if (!this.idIsTreadMail(param.mid)) {
            const singleRes = await this.mailApi.doGetMailContent(param.mid, false, false, undefined, { _account: param.uid });
            if (param.contentType === 1) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(singleRes.entry.content.content
                    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''), 'text/html');
                singleRes.entry.content.content = doc.body.innerText.replace(/\s/g, '');
            }
            res.push(singleRes);
        }
        else {
            let threadRes = await this.mailApi.doGetThreadMailContent(param.mid, { desc: true, limit: param.threadLimit, start: 0 }, false, undefined, param.uid);
            if (threadRes && isArray(threadRes) && threadRes.length > 0) {
                threadRes = threadRes.map(_ => {
                    if (param.contentType === 1) {
                        const parser1 = new DOMParser();
                        const doc = parser1.parseFromString(_.entry.content.content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '').replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''), 'text/html');
                        _.entry.content.content = doc.body.innerText.replace(/\s/g, '');
                    }
                    return _;
                });
                res = threadRes;
            }
        }
        return res;
    }
    mailInfoTransform(data) {
        try {
            if (data && Array.isArray(data) && data.length > 0) {
                return data.map(_ => {
                    var _a, _b;
                    const fromContact = (_a = _ === null || _ === void 0 ? void 0 : _.sender) === null || _a === void 0 ? void 0 : _a.contact.contact;
                    const from = {
                        email: fromContact.hitQueryEmail || fromContact.accountName || '',
                        name: fromContact.contactName,
                        avatar: fromContact.avatar,
                    };
                    const to = [];
                    const cc = [];
                    const bcc = [];
                    _.receiver.forEach(it => {
                        if (it) {
                            const info = {
                                email: it.contact.contact.hitQueryEmail || it.contact.contact.accountName || '',
                                name: it.originName || it.contact.contact.contactName,
                                avatar: it.contact.contact.avatar,
                            };
                            if (it.mailMemberType === 'to') {
                                to.push(info);
                            }
                            else if (it.mailMemberType === 'cc') {
                                cc.push(info);
                            }
                            else if (it.mailMemberType === 'bcc') {
                                bcc.push(info);
                            }
                        }
                    });
                    const body = ((_b = _.entry.content) === null || _b === void 0 ? void 0 : _b.content) || _.entry.brief;
                    return {
                        mid: _.id,
                        uid: _._account || '',
                        subject: _.entry.title,
                        isThread: !!_.isThread,
                        body,
                        isEmptyContent: !body,
                        from,
                        to,
                        cc,
                        bcc,
                        attached: !!(_.entry.attachment && _.entry.attachment.length > 0),
                        isEnAttachedEmail: this.mailConfApi.isSubAccount(_._account || ''),
                    };
                });
            }
            return [];
        }
        catch (ex) {
            return [];
        }
    }
    async doListMailBoxEntitiesByDate(count, index, startDate, endDate, subEmails) {
        const req = {
            index,
            id: -4,
            count,
            subEmails,
            _account: '',
            returnModel: true,
        };
        const res = (await this.mailApi.doListMailBoxEntities(req));
        if (!res.data || res.data.length <= 0 || dayjs(res.data[0].entry.sendTime).valueOf() < startDate) {
            return [];
        }
        const filterRes = res.data.filter(_ => startDate < dayjs(_.entry.sendTime).valueOf() && endDate > dayjs(_.entry.sendTime).valueOf());
        if (filterRes.length >= count) {
            return filterRes.slice(0, count);
        }
        const othersRes = await this.doListMailBoxEntitiesByDate(count - filterRes.length, index + count, startDate, endDate, subEmails);
        return filterRes.concat(othersRes);
    }
    async getMboxUnreadList(param) {
        try {
            const accounts = await this.accountApi.getMainAndSubAccounts({ expired: false });
            const req = {
                index: 0,
                id: -4,
                count: param.limit,
                subEmails: accounts && accounts.length > 1 ? accounts.map(_ => _.id) : [],
                _account: '',
                returnModel: true,
            };
            const res = (await this.mailApi.doListMailBoxEntities(req));
            if (!res.data || res.data.length === 0) {
                return { list: [] };
            }
            const startTime = dayjs().startOf('day').valueOf();
            res.data = res.data.filter(_ => dayjs(_.entry.sendTime).valueOf() > startTime);
            const getContentRequest = [];
            res.data.forEach(_ => {
                getContentRequest.push(this.mailApi.doGetMailContent(_.id, false, false, undefined, { _account: _._account }));
            });
            const contentRes = await Promise.allSettled(getContentRequest);
            const contentResList = contentRes.filter(_ => _.status === 'fulfilled').map(_ => _.value);
            const contentMailMap = {};
            contentResList.forEach(_ => {
                contentMailMap[_.id] = _;
            });
            const data = res.data.map(_ => {
                if (contentMailMap[_.id]) {
                    _.entry = contentMailMap[_.id].entry;
                }
                return _;
            });
            const mailInfoList = this.mailInfoTransform(data);
            return { list: mailInfoList };
        }
        catch (ex) {
            return { list: [] };
        }
    }
    async getSmartAssistantContext() {
        var _a, _b, _c, _d;
        try {
            if (this.multipleActiveIds.length > 0 && this.currentTab.type === 'readMain') {
                const getContentRequest = [];
                this.multipleActiveIds.forEach(_ => {
                    if (!this.idIsTreadMail(_.id)) {
                        getContentRequest.push(this.mailApi.doGetMailContent(_.id, false, false, undefined, { _account: _._account }));
                    }
                    else {
                        getContentRequest.push(this.mailApi.doGetThreadMailContent(_.id, { desc: true, limit: 50, start: 0 }, false, undefined, _._account));
                    }
                });
                const res = await Promise.allSettled(getContentRequest);
                const data = this.mailInfoTransform(res
                    .filter(_ => _.status === 'fulfilled')
                    .map(_ => _.value)
                    .flat());
                return Promise.resolve({
                    from: 'list',
                    data,
                    userInfo: this.getUserInfo(),
                });
            }
            if (this.configMailLayout === '2' && this.currentTab.type === 'readMain') {
                return Promise.resolve({
                    from: 'list',
                    data: [],
                    userInfo: this.getUserInfo(),
                });
            }
            if (this.readMailStatus === MAIL_LOAD_STATUS.EMPTY && this.currentTab.type === 'readMain') {
                return Promise.resolve({
                    from: 'list',
                    data: [],
                    userInfo: this.getUserInfo(),
                });
            }
            if (this.tipOpen) {
                if (this.currentTab.type === 'read') {
                    if ((_b = (_a = this.currentTab) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.originMid) {
                        let res = [];
                        if (!this.idIsTreadMail(this.currentTab.extra.originMid)) {
                            const res1 = await this.mailApi.doGetMailContent(this.currentTab.extra.originMid, false, false, undefined, {
                                _account: this.currentTab.extra.accountId || '',
                            });
                            res = [res1];
                        }
                        else {
                            const res2 = await this.mailApi.doGetThreadMailContent(this.currentTab.extra.originMid, { desc: true, limit: 50, start: 0 }, false, undefined, this.currentTab.extra.accountId || '');
                            res = res2;
                        }
                        const data = res ? this.mailInfoTransform(res) : [];
                        return Promise.resolve({
                            from: 'list',
                            data,
                            userInfo: this.getUserInfo(),
                        });
                    }
                }
                else if (this.readMailStatus === MAIL_LOAD_STATUS.SUCCESS && this.currentTab.type === 'readMain') {
                    if (this.selectedMailId && this.selectedMailId.id) {
                        let res = [];
                        if (!this.idIsTreadMail(this.selectedMailId.id)) {
                            const res1 = await this.mailApi.doGetMailContent(this.selectedMailId.id, false, false, undefined, { _account: this.selectedMailId.accountId || '' });
                            res = [res1];
                        }
                        else {
                            const res2 = await this.mailApi.doGetThreadMailContent(this.selectedMailId.id, { desc: true, limit: 50, start: 0 }, false, undefined, this.selectedMailId.accountId || '');
                            res = res2;
                        }
                        const data = res ? this.mailInfoTransform(res) : [];
                        return Promise.resolve({
                            from: 'list',
                            data,
                            userInfo: this.getUserInfo(),
                        });
                    }
                }
            }
            else if (this.currentTab.type === 'read') {
                if ((_d = (_c = this.currentTab) === null || _c === void 0 ? void 0 : _c.extra) === null || _d === void 0 ? void 0 : _d.originMid) {
                    let res = [];
                    if (!this.idIsTreadMail(this.currentTab.extra.originMid)) {
                        const res1 = await this.mailApi.doGetMailContent(this.currentTab.extra.originMid, false, false, undefined, {
                            _account: this.currentTab.extra.accountId || '',
                        });
                        res = [res1];
                    }
                    else if (this.idIsTreadMail(this.currentTab.extra.originMid) && this.currentMergeMailId) {
                        const res3 = await this.mailApi.doGetMailContent(this.currentMergeMailId, false, false, undefined, {
                            _account: this.currentTab.extra.accountId || '',
                        });
                        res = [res3];
                    }
                    else {
                        const res2 = await this.mailApi.doGetThreadMailContent(this.currentTab.extra.originMid, { desc: true, limit: 1, start: 0 }, false, undefined, this.currentTab.extra.accountId || '');
                        res = res2;
                    }
                    const data = res ? this.mailInfoTransform(res) : [];
                    return Promise.resolve({
                        from: 'read',
                        data: data.length > 0 ? data[0] : {},
                        userInfo: this.getUserInfo(),
                    });
                }
            }
            else if (this.readMailStatus === MAIL_LOAD_STATUS.SUCCESS && this.currentTab.type === 'readMain') {
                if (this.selectedMailId && this.selectedMailId.id) {
                    let res = [];
                    if (!this.idIsTreadMail(this.selectedMailId.id)) {
                        const res1 = await this.mailApi.doGetMailContent(this.selectedMailId.id, false, false, undefined, { _account: this.selectedMailId.accountId || '' });
                        res = [res1];
                    }
                    else if (this.idIsTreadMail(this.selectedMailId.id) && this.currentMergeMailId) {
                        const res3 = await this.mailApi.doGetMailContent(this.currentMergeMailId, false, false, undefined, {
                            _account: this.selectedMailId.accountId || '',
                        });
                        res = [res3];
                    }
                    else {
                        const res2 = await this.mailApi.doGetThreadMailContent(this.selectedMailId.id, { desc: true, limit: 1, start: 0 }, false, undefined, this.selectedMailId.accountId || '');
                        res = res2;
                    }
                    const data = res ? this.mailInfoTransform(res) : [];
                    return Promise.resolve({
                        from: 'read',
                        data: data.length > 0 ? data[0] : {},
                        userInfo: this.getUserInfo(),
                    });
                }
            }
            else if (['replyWithAttach', 'reply'].includes(this.currentTab.type)) {
                const data = this.currentWriteMail ? this.mailInfoTransform([this.currentWriteMail]) : [];
                return Promise.resolve({
                    from: 'write.reply',
                    data,
                    userInfo: this.getUserInfo(),
                });
            }
            else if (['replyAllWithAttach', 'replyAll'].includes(this.currentTab.type)) {
                const data = this.currentWriteMail ? this.mailInfoTransform([this.currentWriteMail]) : [];
                return Promise.resolve({
                    from: 'write.replyAll',
                    data,
                    userInfo: this.getUserInfo(),
                });
            }
            else if (['common', 'forward', 'forwardAsAttach', 'edit', 'editDraft', 'replyAllAsNew'].includes(this.currentTab.type)) {
                return Promise.resolve({
                    from: 'write.general',
                    data: [],
                    userInfo: this.getUserInfo(),
                });
            }
        }
        catch (ex) { }
        return Promise.resolve({
            from: 'list',
            data: [],
            userInfo: this.getUserInfo(),
        });
    }
    onNotification(callback) {
        if (this.eidList.length > 50) {
            return;
        }
        try {
            if (!callback || typeof callback !== 'function') {
                return;
            }
            const eid = this.eventApi.registerSysEventObserver('assistantContextChanged', {
                func: ev => {
                    if (ev && ev.eventData && ev.eventStrData && ev.eventStrData === 'context') {
                        callback({
                            event: 'assistant:contextChanged',
                            payload: ev.eventData,
                        });
                    }
                },
            });
            this.eidList.push(eid);
            return eid;
        }
        catch (ex) { }
    }
    offNotification(eid) {
        try {
            this.eidList = this.eidList.filter(_ => _ !== eid);
            this.eventApi.unregisterSysEventObserver('assistantContextChanged', eid);
        }
        catch (ex) { }
    }
    offAllNotification() {
        try {
            (this.eidList || []).map(_ => this.eventApi.unregisterSysEventObserver('assistantContextChanged', _));
            this.eidList = [];
        }
        catch (ex) { }
    }
    sendNotification(param) {
        try {
            const { type, data } = param;
            this.preAiAssistSideBarVisiable = this.aiAssistSideBarVisiable;
            if (type === 'multipleMail') {
                this.multipleActiveIds = data;
            }
            else if (type === 'readMail') {
                this.readMailStatus = data;
            }
            else if (type === 'currentTab') {
                this.currentTab = data;
            }
            else if (type === 'configMailLayout') {
                this.configMailLayout = data;
            }
            else if (type === 'selectedMailId') {
                this.selectedMailId = data;
            }
            else if (type === 'currentWriteMail') {
                this.currentWriteMail = data;
            }
            else if (type === 'currentMergeMailId') {
                this.currentMergeMailId = data;
            }
            else if (type === 'selectedKeysAccountId') {
                this.selectedKeysAccountId = data;
            }
            else if (type === 'aiAssistSideBarVisiable') {
                this.aiAssistSideBarVisiable = data;
                if (!this.aiAssistSideBarVisiable) {
                    this.preAiAssistSideBarVisiable = false;
                }
            }
            else if (type === 'tipOpen') {
                this.tipOpen = data;
            }
            if (this.preAiAssistSideBarVisiable && this.aiAssistSideBarVisiable) {
                this.sendNotificationHandler();
            }
        }
        catch (ex) { }
    }
    async getMailContent(params) {
        try {
            if (!params || params.length === 0) {
                return [];
            }
            const getContentRequest = [];
            params.forEach(_ => {
                getContentRequest.push(this.doGetMailContent(Object.assign(Object.assign({}, _), { threadLimit: 50 })));
            });
            const res = await Promise.allSettled(getContentRequest);
            const data = this.mailInfoTransform(res
                .filter(_ => _.status === 'fulfilled')
                .map(_ => _.value)
                .flat());
            return data;
        }
        catch (ex) {
            return [];
        }
    }
    async writeMail(param) {
        try {
            const { writeType, action, mid, subject, defaultContent, uid, to = [], cc = [] } = param;
            if (writeType === 'compose') {
                if (['readMain', 'read', 'subordinate'].includes(this.currentTab.type)) {
                    const res = this.mailApi.callWriteLetterFunc({
                        title: subject,
                        originContent: defaultContent,
                        contact: to.map(_ => _.email),
                        ccContact: cc.map(_ => _.email),
                        writeType: 'common',
                        mailType: 'common',
                        mailFormClickWriteMail: uid || this.selectedKeysAccountId || '',
                        _account: uid || this.selectedKeysAccountId || '',
                        withoutPlaceholder: false,
                    });
                }
                else {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'tinymce',
                        eventData: {
                            action,
                            subject,
                            defaultContent,
                        },
                    });
                }
            }
            else if (!defaultContent) {
                if (writeType === 'reply') {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replay' },
                        eventStrData: 'closeCurReadTab_before',
                        _account: uid,
                    });
                    const res = await this.mailApi.doReplayMail(mid, false, undefined, undefined, uid);
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replay' },
                        eventStrData: 'closeCurReadTab_after',
                        _account: uid,
                    });
                }
                else if (writeType === 'replyAll') {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replayAll' },
                        eventStrData: 'closeCurReadTab_before',
                        _account: uid,
                    });
                    const res = await this.mailApi.doReplayMail(mid, true, undefined, undefined, uid);
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replayAll' },
                        eventStrData: 'closeCurReadTab_after',
                        _account: uid,
                    });
                }
            }
            else if (writeType === 'reply' || writeType === 'replyAll') {
                if (this.currentTab && this.currentTab.extra && this.currentTab.extra.originId === mid) {
                    this.eventApi.sendSysEvent({
                        eventName: 'assistantContextChanged',
                        eventStrData: 'tinymce',
                        eventData: {
                            action,
                            subject,
                            defaultContent,
                        },
                    });
                }
                else {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: writeType === 'reply' ? 'replay' : 'replayAll' },
                        eventStrData: 'closeCurReadTab_before',
                        _account: uid,
                    });
                    const res = await this.mailApi.doReplayMail(mid, writeType === 'replyAll', undefined, defaultContent, uid);
                    this.eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: writeType === 'reply' ? 'replay' : 'replayAll' },
                        eventStrData: 'closeCurReadTab_after',
                        _account: uid,
                    });
                }
            }
        }
        catch (ex) { }
        return Promise.resolve(param);
    }
    notification(param) {
        const { name } = param || {};
        console.log('下属AI助手发来的通知', name);
        if (name === 'aiAssistant:startSearching') {
        }
        else if (name === 'aiAssistant:endSearching') {
        }
        else if (name === 'AI_ASSISTANT_EXTRACT_MAIL') {
            console.log(4444, '同步邮件列表notification', param);
            storeOps.mail.extractMailFromAI((param.object || param.data));
        }
    }
    readMail(param) {
        try {
            const { uid, mid, isResign } = param || {};
            if (!uid || !mid) {
                console.error('查看邮件, 缺少必要参数', param);
                return;
            }
            if (isResign) {
                window.open(`${this.systemApi.getContextPath()}/readMail/?resignMid=${mid}&id=${mid}&resignEmail=${uid}&${isResign ? '&isResign=1' : ''}`);
                return;
            }
            storeOps.mail.readMailFromAI(param);
        }
        catch (error) {
            console.error('下属AI助手，readMail', error);
        }
    }
    openFile(param) {
        var _a;
        try {
            const { file } = param || {};
            const { uid, id, name, mid, originContent } = file || {};
            const { tid, inlined, encoding, fileName, contentLength, contentType, estimateSize, colleagueAccId, partId } = originContent || {};
            const attments = {
                filename: fileName || name,
                contentId: id,
                estimateSize,
                contentLength,
                id: +partId || +id,
                encoding,
                contentType,
                inlined,
                _account: uid,
            };
            const params = {
                forWrite: false,
                fromIMDisscuss: false,
                isTpMail: !!colleagueAccId,
                owner: uid,
                tid,
                mailFrom: 'subordinate',
                colleagueAccId,
                mainAccount: (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
            };
            const attmentsRes = this.mailApi.openFilehandleAttachment([attments], mid, params);
            if (Array.isArray(attmentsRes) && attmentsRes.length) {
                const downloadInfo = attmentsRes[0];
                if (downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment) {
                    const { cloudIdentity } = downloadInfo;
                    const filePreviewUrl = `${this.systemApi.getUrl('previewCloudAttGeneric')}?identity=${cloudIdentity}&p=web`;
                    if (process.env.BUILD_ISWEB) {
                        const cloudUrl = document.createElement('a');
                        const href = getFeiShuUrl(filePreviewUrl);
                        cloudUrl.href = href;
                        cloudUrl.target = '_blank';
                        cloudUrl.click();
                    }
                    return;
                }
                const type = downloadInfo.fileType;
                if (type && IMG_TYPES.includes(type)) {
                    storeOps.mail.openFileFromAI(attmentsRes);
                    return;
                }
                if (process.env.BUILD_ISWEB) {
                    const searchStrArr = ATTACHMENT_KEYS.map(k => `${k}=${encodeURIComponent((downloadInfo && downloadInfo[k]) || '')}`);
                    const searchStr = searchStrArr.join('&');
                    window.open(`${this.systemApi.getContextPath()}/attachment/?${getDingTalkSearchString(false, true)}outDownloadContentId=${encodeURIComponent(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId)}&${searchStr}`);
                }
            }
        }
        catch (error) {
            console.error('查看附件，openFile', error);
        }
    }
    extractMail(param) {
        try {
            const { searchPayload, list } = param || {};
            const { searchUrl } = searchPayload || {};
            if (!!searchPayload && !searchUrl) {
                console.error('extractMail, 缺少参数', param);
                return;
            }
            if (!searchPayload && (!Array.isArray(list) || !list.length)) {
                console.error('extractMail, 缺少参数', param);
                return;
            }
            console.log(4444, '同步邮件列表extractMail', Object.assign({}, param));
            storeOps.mail.extractMailFromAI(Object.assign(Object.assign({}, param), { gotoSd: !!searchPayload }));
        }
        catch (error) {
            console.error('下属AI助手，extractMail', error);
        }
    }
    persisentStoreSetItem(param) {
        var _a;
        try {
            const { key, value } = param;
            if (key) {
                const originObjStr = (_a = this.storageApi.getSync(STORE_KEY)) === null || _a === void 0 ? void 0 : _a.data;
                const obj = originObjStr ? JSON.parse(originObjStr) : {};
                this.storageApi.putSync(STORE_KEY, JSON.stringify(Object.assign(Object.assign({}, obj), { [key]: value || '' })));
                return { ok: true };
            }
            console.error('persisentStoreSetItem need key');
            return { ok: false };
        }
        catch (error) {
            console.error('persisentStoreSetItem error:', error);
            return { ok: false };
        }
    }
    persisentStoreGetItem(param) {
        var _a;
        try {
            const { key } = param;
            if (key) {
                const originObjStr = (_a = this.storageApi.getSync(STORE_KEY)) === null || _a === void 0 ? void 0 : _a.data;
                const obj = originObjStr ? JSON.parse(originObjStr) : {};
                if (Object.keys(obj).includes(key)) {
                    return { ok: true, value: obj[key] || '' };
                }
                return { ok: false, value: '' };
            }
            console.error('persisentStoreGetItem need key');
            return { ok: false, value: '' };
        }
        catch (error) {
            console.error('persisentStoreGetItem error:', error);
            return { ok: false, value: '' };
        }
    }
    persisentStoreRemoveItem(param) {
        var _a;
        try {
            const { key } = param;
            if (key) {
                const originObjStr = (_a = this.storageApi.getSync(STORE_KEY)) === null || _a === void 0 ? void 0 : _a.data;
                const obj = originObjStr ? JSON.parse(originObjStr) : {};
                if (Object.keys(obj).includes(key)) {
                    delete obj[key];
                    this.storageApi.putSync(STORE_KEY, JSON.stringify(obj));
                    return { ok: true };
                }
                return { ok: true };
            }
            console.error('persisentStoreRemoveItem need key');
            return { ok: false };
        }
        catch (error) {
            console.error('persisentStoreRemoveItem error:', error);
            return { ok: false };
        }
    }
    async removeMail(params) {
        console.log(4444, 'removeMailFromAI', params);
        return storeOps.mail.removeMailFromAI(params);
    }
    async setMailRead(params) {
        console.log(4444, 'setMailReadFromAI', params);
        return storeOps.mail.setMailReadFromAI(params);
    }
    async setMailFlag(params) {
        console.log(4444, 'setMailFlagFromAI', params);
        return storeOps.mail.setMailFlagFromAI(params);
    }
    showToast(param) {
        this.eventApi.sendSysEvent({
            eventName: 'assistantContextChanged',
            eventStrData: 'toast',
            eventData: param,
        });
    }
    stat(param) {
        console.log(4444, 'AI打点:', param);
        this.trackApi.track(param.name, param.data);
    }
    toggleSmartAssistant() {
        try {
            storeOps.mail.updateAiAssistVisiable();
        }
        catch (ex) { }
    }
    init() {
        return this.name;
    }
    afterInit() {
        return this.name;
    }
    openUrlInBrowser(params) {
        window.open(params.url, '_blank');
    }
    getSkinInfo() {
        const { data } = storeApi.getSync('system_theme', { noneUserRelated: true });
        let isDark = false;
        const isDarkThemeMod = window && window.matchMedia('(prefers-color-scheme: dark)').matches;
        if ((data === 'auto' && isDarkThemeMod) || data === 'dark') {
            isDark = true;
        }
        return {
            skin: data,
            isDark,
        };
    }
    onSkinDidChange(callback) {
        if (this.eidList.length > 50) {
            return;
        }
        try {
            if (!callback || typeof callback !== 'function') {
                return;
            }
            const eid = this.eventApi.registerSysEventObserver('themeChanged', {
                func: ev => {
                    if (ev && ev.eventData && ev.eventStrData && ev.eventStrData === 'skininfo') {
                        callback({
                            isDark: ev.eventData.isDark,
                            skin: ev.eventData.skin,
                        });
                    }
                },
            });
            this.eidList.push(eid);
        }
        catch (ex) { }
    }
    async queryMails(params) {
        try {
            if (params.keyword) {
                const resp = await this.mailApi.doSearchMoreAccounts(params.keyword || '', {
                    count: params.limit || 0,
                    order: params.order,
                    desc: params.orderDesc,
                });
                return {
                    list: resp
                        .filter(item => !item.entry.isDraft)
                        .map(item => {
                        var _a;
                        return ({
                            mid: item.entry.id,
                            sendTime: item.entry.sendTime,
                            subject: item.entry.title,
                            from: {
                                name: item.sender.contact.contact.accountName,
                                email: item.sender.contact.contact.accountId,
                            },
                            isThread: false,
                            uid: (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                        });
                    }),
                };
            }
            const accounts = await this.accountApi.getMainAndSubAccounts({ expired: false });
            const result = await this.mailApi.doListMailBoxEntities({
                count: params.limit || 0,
                order: params.order,
                desc: params.orderDesc,
                filter: {},
                id: 1,
                subEmails: accounts && accounts.length > 1 ? accounts.map(_ => _.id) : [],
            });
            return {
                list: result.data
                    .filter(item => !item.entry.isDraft)
                    .map(item => {
                    var _a;
                    return ({
                        mid: item.entry.id,
                        sendTime: item.entry.sendTime,
                        subject: item.entry.title,
                        from: {
                            name: item.sender.contact.contact.accountName,
                            email: item.sender.contact.contact.accountId,
                        },
                        isThread: false,
                        uid: (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                    });
                }),
            };
        }
        catch (error) {
            return [];
        }
    }
    getMiniApp() {
        return singletonMiniApp;
    }
    openMiniApp(params) {
        singletonMiniApp.openMiniApp(params);
    }
    dismissFromMiniApp(params) {
        singletonMiniApp.dismissFromMiniApp(params);
    }
    getMiniAppContext() {
        return singletonMiniApp.getMiniAppContext();
    }
    async pickMailFolder() {
        const promise = new Promise((resolve, reject) => {
            const eventId = this.eventApi.registerSysEventObserver('AIAssistantEvent', {
                func: ev => {
                    var _a, _b, _c, _d, _e, _f;
                    if (ev && ev.eventStrData && ev.eventStrData === 'folderSelected') {
                        this.eventApi.unregisterSysEventObserver('AIAssistantEvent', eventId);
                        console.log('xxx', ev.eventData);
                        if (((_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.key) === 100000000) {
                            resolve({
                                ok: true,
                                result: {
                                    id: 'all_1',
                                    name: '所有收件箱',
                                    type: 1,
                                    parent: '',
                                },
                            });
                            return;
                        }
                        const mboxData = (_b = ev.eventData) === null || _b === void 0 ? void 0 : _b.mboxData;
                        const accountId = (_c = ev.eventData) === null || _c === void 0 ? void 0 : _c.accountId;
                        const result = {
                            id: mboxData === null || mboxData === void 0 ? void 0 : mboxData.mailBoxId,
                            name: (_d = mboxData === null || mboxData === void 0 ? void 0 : mboxData.entry) === null || _d === void 0 ? void 0 : _d.mailBoxName,
                            type: (mboxData === null || mboxData === void 0 ? void 0 : mboxData.mailBoxId) >= 100 ? 20 : mboxData === null || mboxData === void 0 ? void 0 : mboxData.mailBoxId,
                            parent: (_e = mboxData === null || mboxData === void 0 ? void 0 : mboxData.entry) === null || _e === void 0 ? void 0 : _e.pid,
                            uid: accountId,
                            encrypted: (_f = mboxData === null || mboxData === void 0 ? void 0 : mboxData.entry) === null || _f === void 0 ? void 0 : _f.locked,
                        };
                        console.log('xxx-folderSelected', result);
                        resolve({
                            ok: true,
                            result,
                        });
                    }
                },
            });
        });
        this.eventApi.sendSysEvent({
            eventName: 'AIAssistantEvent',
            eventStrData: 'folderSelect',
            eventData: {},
        });
        return promise;
    }
    navigateTo(params) {
        var _a, _b;
        if ((params === null || params === void 0 ? void 0 : params.path) === 'web' && ((_a = params === null || params === void 0 ? void 0 : params.params) === null || _a === void 0 ? void 0 : _a.url)) {
            window.open((_b = params === null || params === void 0 ? void 0 : params.params) === null || _b === void 0 ? void 0 : _b.url);
        }
    }
}
const aiAssistant = new AiAssistant();
api.registerLogicalApi(aiAssistant);
export default aiAssistant;
